import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=b8271a46"
import script from "./upload-image.vue?vue&type=script&lang=ts"
export * from "./upload-image.vue?vue&type=script&lang=ts"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=b8271a46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports